import { h, render } from 'preact'; // eslint-disable-line no-unused-vars

export const CarsIcon = () => (
  <div className="cars-icon icon-wrapper">
    <svg className="icon icon__cars" xmlns="http://www.w3.org/2000/svg" width="23.83" height="30" viewBox="0 0 23.83 30">
      <g>
        <path d="M21.08,10.14A2,2,0,0,0,19.2,8.81H4.63a2,2,0,0,0-1.88,1.32L0,18.08V28.67A1.32,1.32,0,0,0,1.32,30H2.65A1.32,1.32,0,0,0,4,28.67V27.35H19.86v1.32A1.32,1.32,0,0,0,21.18,30h1.32a1.32,1.32,0,0,0,1.32-1.32V18.08ZM4.63,23.38a2,2,0,1,1,2-2,2,2,0,0,1-2,2Zm14.56,0a2,2,0,1,1,2-2,2,2,0,0,1-2,2ZM2.65,16.76l2-6H19.2l2,6Z"/>
        <path d="M-4,2.19H27.8V34H-4Z" style="fill: none"/>
      </g>
    </svg>
  </div>
);

export default () => {
  [...document.getElementsByTagName('CarsIcon')].forEach((el) => {
    render(CarsIcon, el, CarsIcon.children);
  });
};
